import { SelectionActionType, SelectionActions } from './actions';

export interface SelectionState {
  selectedClients: Array<string>;
  selectedVehicles: Array<string>;
  selectedSupervisors: Array<string>;
}

export const getInitialState = (): SelectionState => ({
  selectedClients: [],
  selectedVehicles: [],
  selectedSupervisors: [],
});

export const SelectionReducer = (state: SelectionState, action: SelectionActions): SelectionState => {
  switch (action.type) {
    case SelectionActionType.SET_SELECTED_CLIENTS:
      return {
        ...state,
        selectedClients: action.payload.selectedClients,
      };
    case SelectionActionType.SET_SELECTED_VEHICLES:
      return {
        ...state,
        selectedVehicles: action.payload.selectedVehicles,
      };
    case SelectionActionType.SET_SELECTED_SUPERVISORS:
      return {
        ...state,
        selectedSupervisors: action.payload.selectedSupervisors,
      };
    default:
      return state;
  }
};
